module.exports = __webpack_public_path__ + "img/60.22b96fdc.webp";